// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__5_7DH","name":"ConsentHeader_name__2YI26","birthday":"ConsentHeader_birthday___3Maa","skeleton":"ConsentHeader_skeleton__w_YCe"};